import React from "react";
import banner from "../assets/products.jpg";
import { Card } from "primereact/card";
import { NavLink } from "react-router-dom";
export default function Services() {
return(
  
    <div>
       <div
        style={{
          width: "100%",
          height: "300px",         
          backgroundImage: `url(${banner})`,
          backgroundSize: "cover",  
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff"
        }}
      >
        <h1>Services</h1>
      </div>
      <div className="p-5">
      <div className="center-text-section">
        <h2>Overview of services provided by PESIL</h2>
        <p>
          We provides services for IBM products and migrations in IBM Platform


        </p>
      </div>
      <div className="grid mt-5">
        <a>
          
        </a>
<div className="grid">

  {/* Card 1 */}
  <div className="col-12 md:col-4 flex">
    <div className="hover-card flex w-full">

      <NavLink to="/hosting" className="card-link w-full">
        <Card
          title="IBM JAZZ Platform Hosting and Maintenance"
          className="flex flex-column justify-content-between w-full"
        >
          <p>
            We develop high-quality, scalable software solutions to meet your business needs.
          </p>
        </Card>
      </NavLink>

    </div>
  </div>

  {/* Card 2 */}
  <div className="col-12 md:col-4 flex">
    <div className="hover-card flex w-full">

      <Card
        title="Develop Custom Reports"
        className="flex flex-column justify-content-between w-full"
      >
        <p>Using Rational Publishing Engine</p>
      </Card>

    </div>
  </div>

  {/* Card 3 */}
  <div className="col-12 md:col-4 flex">
    <div className="hover-card flex w-full">

      <Card
        title="IBM Jazz Server Installation and Upgrade Services"
        className="flex flex-column justify-content-between w-full"
      >
        <p>
          We provide installation and upgrade services for IBM Rational Jazz Platform.
        </p>
      </Card>

    </div>
  </div>

</div>


        {/* <div className="col-12 md:col-4">
          <div className="hover-card">
            <Card title="Consulting">
              <p>Expert guidance for enterprise solutions.</p>
            </Card>
          </div>
        </div> */}
      </div>

    </div>
      </div>
)
}
